module.exports = "https://static.wagwalking.com/_next/static/images/walk-1-bec0502dcfc2a83548f3ddcc0b704ceb.svg";